import React from "react";
import icon1 from "../../../../assets/images/appIcons/chat.svg";
import icon2 from "../../../../assets/images/appIcons/search.svg";
import icon3 from "../../../../assets/images/appIcons/synchronization.svg";
import icon4 from "../../../../assets/images/appIcons/geolocation.svg";
import icon5 from "../../../../assets/images/appIcons/payment.svg";
import icon6 from "../../../../assets/images/appIcons/notification.svg";
import icon7 from "../../../../assets/images/appIcons/wifi.svg";
import icon8 from "../../../../assets/images/appIcons/calander.svg";
import icon9 from "../../../../assets/images/appIcons/connectino.svg";
import icon10 from "../../../../assets/images/appIcons/rating.svg";
import icon11 from "../../../../assets/images/appIcons/qrcode.svg";
import icon12 from "../../../../assets/images/appIcons/analytics.svg";

const iconsRow1 = [icon1, icon2, icon3, icon4, icon5, icon6];
const iconsRow2 = [icon7, icon8, icon9, icon10, icon11, icon12];

function Application() {
  return (
    <section className="relative py-20 overflow-hidden bg-white">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-80 h-80 bg-blue-100 opacity-30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-100 opacity-30 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-purple-100 opacity-20 rounded-full blur-3xl"></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6">
            A Tailor-made
            <span className="text-blue-600"> Applications</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We adapt to all your needs to offer the best user experience ever, 
            creating custom solutions that perfectly fit your business requirements.
          </p>
        </div>

        {/* Icons Animation Section */}
        <div className="space-y-8">
          {/* First Row */}
          <div className="overflow-hidden">
            <div className="flex animate-marquee gap-8">
              {iconsRow1.map((icon, index) => (
                <Card key={`row1-${index}`} icon={icon} />
              ))}
              {iconsRow1.map((icon, index) => (
                <Card key={`row1-${index}-2`} icon={icon} />
              ))}
              {iconsRow1.map((icon, index) => (
                <Card key={`row1-${index}-3`} icon={icon} />
              ))}
              {iconsRow1.map((icon, index) => (
                <Card key={`row1-${index}-4`} icon={icon} />
              ))}
            </div>
          </div>

          {/* Second Row */}
          <div className="overflow-hidden">
            <div className="flex animate-marquee1 gap-8">
              {iconsRow2.map((icon, index) => (
                <Card key={`row2-${index}`} icon={icon} />
              ))}
              {iconsRow2.map((icon, index) => (
                <Card key={`row2-${index}-2`} icon={icon} />
              ))}
              {iconsRow2.map((icon, index) => (
                <Card key={`row2-${index}-3`} icon={icon} />
              ))}
              {iconsRow2.map((icon, index) => (
                <Card key={`row2-${index}-4`} icon={icon} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const Card = ({ icon }) => {
  return (
    <div className="flex-none group">
      <div className="w-28 h-28 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl flex items-center justify-center border border-gray-200 hover:shadow-lg hover:border-gray-300 transition-all duration-300 group-hover:scale-101">
        <img
          src={icon}
          alt="Icon"
          className="group-hover:scale-110 transition-transform duration-300 w-25 h-25"
        />
      </div>
    </div>
  );
};

export default Application;
